import { Attributes } from '@trp-ta-nitro/otel-browser-js';
import { getGlobalSpanRegistrar } from './otel';

const resourceAttributes = new Attributes.Resource.ResourceAttributes();
const siteAttributes = new Attributes.Site.SiteAttributes();

export function finalizeApploadSpan(appMetadata, success = true) {
  const apploadSpan = getGlobalSpanRegistrar().getSpan('appload');
  if (!apploadSpan) {
    console.error('handling appLoaded(), missing appload span');
    return;
  }

  const pathname = window.location.pathname;

  if (appMetadata.accounts) {
    apploadSpan.setAttribute('aam.accounts.count', appMetadata.accounts);
  }
  if (appMetadata.products) {
    apploadSpan.setAttribute('aam.products.types', appMetadata.products);
  }
  if (appMetadata.aum) {
    apploadSpan.setAttribute('aam.user.aum', appMetadata.aum);
  }
  if (appMetadata.uberId) {
    apploadSpan.setAttribute('aam.user.uberId', appMetadata.uberId);
  }
  apploadSpan.setAttribute('aam.page', pathname);
  apploadSpan.setAttribute('aam.load.success', success);

  resourceAttributes.addAttributes(apploadSpan);
  siteAttributes.addAttributes(apploadSpan);

  apploadSpan.end();
}
